import cn from 'classnames';
import { useMemo, useRef } from 'react';

import { createId } from '@scripts/createId';

import styles from './Accordion.module.scss';
import { AccordionItemContext, useAccordionContext } from './context';
import { AccordionItemProps } from './types';

const ACCORDION_ITEM_ID_LENGTH = 6;

export const AccordionItem = ({ children, uuid, className, ...props }: AccordionItemProps) => {
    const generatedIdRef = useRef<string>(`accordion-${createId(ACCORDION_ITEM_ID_LENGTH)}`);
    const { isItemExpanded } = useAccordionContext();
    const itemId = uuid ?? generatedIdRef.current;

    const itemContextValue = useMemo(
        () => ({
            itemId,
            buttonId: `${itemId}-button`,
            panelId: `${itemId}-panel`,
            expanded: isItemExpanded(itemId),
        }),
        [itemId, isItemExpanded]
    );

    return (
        <AccordionItemContext.Provider value={itemContextValue}>
            <div className={cn(styles.item, className)} {...props}>
                {children}
            </div>
        </AccordionItemContext.Provider>
    );
};
